<template>
   <div class="tableFixHead">
        <table class="table align-middle table-row-dashed fs-6 fw-bold gy-4" id="datatable_variation">
            <thead class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <tr class="fw-bolder fs-7 text-uppercase text-center gs-0">
                    <th class="text-center capitalize" >{{ $t('expenses.label.title') }}</th>
                    <th class="text-center capitalize" >{{ $t('expenses.label.amount') }}</th>
                    <th class="text-center capitalize" >{{ $t('expenses.label.createdBy') }}</th>
                    <th class="text-center capitalize" >{{ $t('expenses.label.status') }}</th>
                    <th class="text-center capitalize" >{{ $t('expenses.label.validatedAt') }}</th>
                    <th class="text-center capitalize" >{{ $t('expenses.label.createdAt') }}</th>
                    <th class="text-center capitalize" >{{ $t('actions') }}</th>
                </tr>
            </thead>
          <tbody :id="id" v-if="loading">
          <tr
              style="height :40vh !important;width: 100%!important;">
            <td colspan="7" >
              <div class="h-200px d-flex justify-content-center align-items-center">
                <div class="text-center">
                  <div class="spinner-border" role="status">
                    <span class="visually-hidden">{{ $t("loadingText") }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
          <tbody :id="id" v-else-if="!Object.values(officeExpenses).length">
          <tr
              style="height :40vh !important;width: 100%!important;">
            <td colspan="7" >
              <div class=" text-center ">
                <div class="pt-8 ">
                  <Img filename="empty.png" alt=""
                       class="mw-100 h-125px h-sm-175px" />
                </div>
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('expenses.noExpenses') }}</h2>
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else :id="id">
                <tr v-for="expense in officeExpenses" :key="expense?.id" style="cursor: pointer;">
                    <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center" >
                        {{ expense?.title }}
                    </td>
                    <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center " >
                        {{ formatAmount(expense?.fees_sum_amount) }}
                    </td>
                    <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center " >
                        {{ expense?.user?.fullname }}
                    </td>
                    <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center" >
                        <span class="badge" :style="{ backgroundColor: $getCssVariable(expense.status_color) }" >
                            {{ expense['status_'+locale] }}
                        </span>
                   </td>
                  <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center " >
                    {{ expense?.validate_date  ? new Date(expense?.validate_date)?.toLocaleDateString() : '-' }}
                  </td>
                  <td @click.prevent="goToExpenseDetails(expense?.id)" class="text-center " >
                      {{ new Date(expense?.created_at)?.toLocaleDateString() }}
                    <i class="flaticon flaticon-like"></i>
                  </td>
                  <td class="text-center">
                    <a @click.prevent="goToExpenseDetails(expense?.id)" href="javascript:;" class="btn btn-sm btn-clean btn-icon " ><i class="fas fa-eye fs-2" data-toggle="tooltip" data-placement="top" :title="$t('button.show')" ></i></a>
                    <a v-if="canDo(expense.status, [expenseStatusEnums.UNVALIDATED]) && $can(abilities.APPROVED_EXPENSE)" @click.prevent="approveExpense(expense.id)" href="javascript:;" class="btn btn-sm btn-clean btn-icon " ><i class="fa fa-thumbs-up fs-2" data-toggle="tooltip" data-placement="top" :title="$t('expenses.approve')"></i></a>
                    <a v-if="canDo(expense.status, [expenseStatusEnums.APPROVED]) && $can(abilities.VALIDATE_EXPENSE)" @click.prevent="validateExpense(expense.id)" href="javascript:;" class="btn btn-sm btn-clean btn-icon " ><i class="fa fa-check fs-2" data-toggle="tooltip" data-placement="top" :title="$t('expenses.validate')" ></i></a>
                    <a v-if="canDo(expense.status, [expenseStatusEnums.UNVALIDATED,expenseStatusEnums.VALIDATED,expenseStatusEnums.APPROVED]) && $can(abilities.REJECT_EXPENSE)" @click.prevent="rejectExpense(expense.id)" href="javascript:;" class="btn btn-sm btn-clean btn-icon " ><i class="fa fa-times fs-2" data-toggle="tooltip" data-placement="top" :title="$t('expenses.reject')"></i></a>
                  </td>
                </tr>
            </tbody>
        </table>
    </div>
  <RejectExpenseModal id="reject_expense" :data="formRejectData" :callback="handleReload"/>
</template>
  
<script setup> 
import { useFormatAmount } from "@/composables/formatAmount";
import {onMounted, ref} from "vue";
import { useRouter,  } from "vue-router";
import {useLocales} from "@/composables/locales";
import Img from "@/components/Img.vue";
import abilities from "@/composables/abilities";
import {useExpenseEnums} from "@/Modules/Financial/composables/expenseEnums";
import {useSwal} from "@/composables/useSwal";
import RejectExpenseModal from "@/Modules/Financial/views/Accounting/components/RejectExpenseModal.vue";
import {useStore} from "vuex";

const store = useStore()
const router = useRouter()
const { locale } = useLocales()
const { expenseStatusEnums } = useExpenseEnums()
const {formatAmount} = useFormatAmount()
const {showSwal} = useSwal()

const emits = defineEmits(['reloadData'])
const props = defineProps({
  loading: { type: Boolean, default: false },
  officeExpenses: {type: Object, default: () => ({})},
  id: {type: String, default: 'kt_td_picker_button'},
})

const formRejectData = ref({
  id: '',
  motif: ''
})


function canDo(status, abilities) {
  return abilities.includes(status);
}
const goToExpenseDetails = (id) => {
    router.push({name:"office-user-expense-details", params:{id}})
}
function approveExpense(id) {
  showSwal(
      i18n.global.t('swal.approve'),
      i18n.global.t('swal.approve_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('expenses/approveExpense', id)
          .then(() => {
            handleReload()
            window.toastr['success'](i18n.global.t('notification.expense_validated'))
          })
          .catch(() => {
          })
          .finally(() => {})
    }
  })
}
function validateExpense(id) {
  showSwal(
      i18n.global.t('swal.validate'),
      i18n.global.t('swal.validate_text')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('expenses/validateExpense', id)
          .then(() => {
            handleReload()
            window.toastr['success'](i18n.global.t('notification.expense_validated'))
          })
          .catch(() => {
          })
          .finally(() => {})
    }
  })
}
function rejectExpense(id) {
  showSwal(
      i18n.global.t('swal.reject'),
      i18n.global.t('swal.reject_text')
  ).then( async (result) => {
    if (result.value) {
      formRejectData.value = {
        id,
        motif: ''
      }
      $("#reject_expense").modal('toggle');
    }
  })
}

function handleReload() {
  emits('reloadData')
}

onMounted(() => {
})

</script>
  